import Icons from 'components/Icons';
import MediaGallery from 'components/MediaGallery';
import Separator from 'components/Separator';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import actions from 'store/actions';
import './listingDetail.scss'
import OpenHouse from './modules/OpenHouse';
import Tabs from './modules/Tabs';
import InquiryForm from './modules/InquiryForm';
import Talk from 'talkjs';
import NoUser from 'assets/images/no_user.jpg'
import { checkImageUrl, formatCurrency } from 'utils/modules/Handlers';
import { Config } from 'utils';
import PageWrapper from 'components/PageWrapper';
import CustomContainer from 'components/CustomContainer';
import ListingStatus from 'components/ListingStatus';
import moment from 'moment';
import WeeklyCalendar from 'components/WeeklyCalendar';
import CustomButton from 'components/CustomButton';
// Packages
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import ListingCard from 'components/ListingCard';
import Loading from 'components/Icons/modules/Loading';
import AuthForms from './modules/AuthForms';


const ListingDetail = () => {
    const { id, mls } = useParams();
    const { public: { listing, loading } } = useSelector((state) => state.listing);
    const { buyerAgents: myAgents } = useSelector((state) => state.agent)
    const { user } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [documents, setDocuments] = useState([]);
    const [talkLoaded, markTalkLoaded] = useState(false);
    const [sessionData, setSessionData] = useState(null);
    const [popupData, setPopupData] = useState(null);
    const navigate = useNavigate();
    const { saved: savedListings } = useSelector((state) => state.listing)
    const [nearbyListing, setNearbyListing] = useState([])
    const [similarListing, setSimilarListing] = useState([])
    const [loadingProperties, setLoadingProperties] = useState(true)
    const [modal, setModal] = useState(false);
    const [profile, setProfile] = useState({})

    useEffect(() => {
        const init = async () => {
            await dispatch(actions.listing.retrievePublicListing({ mls, id }))
            if (user.id) {
                if (user.user_type === 'buyer' || user.user_type === 'seller') {
                    await dispatch(actions.agent.fetchBuyerAgents());
                    if (user.id && (user.user_type === 'buyer' || user.user_type === 'seller')) {
                        const data = await dispatch(actions.buyer.fetchBuyerProfile());
                        if (data.length > 0) {
                            setProfile(data[0]);
                        }
                    }
                }
                await dispatch(actions.listing.fetchSavedListings())
            }
        }
        init()
    }, [])


    useEffect(() => {
        const init = async () => {
            if (user.id && listing.id) {
                try {
                    await dispatch(actions.listing.fetchListingDocuments({ id: listing.id, is_public: true })).then((data) => {
                        setDocuments(data.results);
                    });
                } catch (error) {
                    console.log(error)
                }
            }
        }

        init();
    }, [listing])

    useEffect(() => {
        const init = async () => {
            if (listing.id) {
                const nearby = await dispatch(actions.listing.nearbyListings({ filters: `address=${listing.state},${listing.city},${listing.zip_code}` }));
                const similar = await dispatch(actions.listing.nearbyListings({ filters: `type=${listing.type}&status=${listing.listing_status}&sale_rent=${listing.sale_rent}` }));
                setNearbyListing(nearby.results);
                setSimilarListing(similar.results);
                setLoadingProperties(false);
            }
        }

        init();
    }, [listing])

    useEffect(() => {
        const initPopUpMessage = async () => {
            Talk.ready.then(() => markTalkLoaded(true));
            if (listing.id && user.id && user.user_type === 'agent' && talkLoaded) {
                const currentUserData = new Talk.User({
                    id: user.id,
                    name: `${user.first_name} ${user.last_name}`,
                    email: user.email,
                    photoUrl: checkImageUrl(user.profile_photo, NoUser),
                    role: user.user_type,
                });

                const otherUserData = new Talk.User({
                    id: listing?.agent_data.user,
                    name: listing?.agent_data.full_name,
                    email: listing?.agent_data.email,
                    photoUrl: checkImageUrl(listing?.agent_data.profile_photo, NoUser),
                    role: listing?.agent_data.user_type,
                });

                const session = new Talk.Session({
                    appId: Config.TalkJS_APP_ID,
                    me: currentUserData,
                });

                const conversation = session.getOrCreateConversation(
                    Talk.oneOnOneId(currentUserData, otherUserData)
                );

                conversation.setParticipant(currentUserData);
                conversation.setParticipant(otherUserData);
                try {
                    const otherUser = {
                        name: listing?.agent_data.full_name,
                        email: [listing?.agent_data.email],
                        photoUrl: checkImageUrl(listing?.agent_data.profile_photo, NoUser),
                        role: listing?.agent_data.user_type,
                    }
                    const currentUser = {
                        name: `${user.first_name} ${user.last_name}`,
                        email: [user.email],
                        photoUrl: checkImageUrl(user.profile_photo, NoUser),
                        role: user.user_type,
                    }
                    await dispatch(actions.message.updateCreateUser({ id: otherUserData.id, data: otherUser }));
                    await dispatch(actions.message.updateCreateUser({ id: currentUserData.id, data: currentUser }));
                    await dispatch(actions.message.createConversation({ id: conversation.id, data: { participants: [currentUserData.id.toString(), otherUserData.id.toString()] } }));
                } catch (error) {
                    console.log(error);
                }

                const popup = session.createPopup();
                popup.select(conversation);
                popup.mount({ show: false });

                setSessionData(session)
                setPopupData(popup)

            }
        }
        initPopUpMessage();
    }, [listing, talkLoaded, user])


    useEffect(() => {
        if (sessionData && popupData) {
            return () => {
                popupData.destroy();
                sessionData.destroy();
            };
        }
    }, [popupData, sessionData]);


    const onViewGallery = () => {
        navigate(`/listings/${listing.mls_source}/${listing.mls_number || listing.id}/gallery/`)
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const showingInstance = async () => {
        const body = {
            mls_source: listing.mls_source,
            mls_number: listing.mls_number,
            listing_id: listing.id,
        }
        await dispatch(actions.showing.showingRequestStep1(body)).then(async () => {
            if (profile.default_buyer_agent || myAgents.length > 0) {
                const body = {
                    showing: localStorage.getItem('showingId'),
                    buyer_agent: profile?.default_buyer_agent?.id || myAgents[0].id,
                }
                await dispatch(actions.showing.showingRequestStep2Agent(body))
                navigate(`/request/${mls}/${id}/calendar`)
            } else {
                navigate(`/request/${mls}/${id}/choose-agent/?next=calendar`)
            }
        })
    }


    const onSchedule = useCallback(() => {
        if (user.id) {
            if (listing.showing_service_status === 'enabled') {
                if (Object.keys(user).length > 0) {
                    if (user.user_type === 'agent') {
                        if (user.agent_profile.id === listing.agent) {
                            navigate(`/manage-listings/${listing.id}/showing-form`)
                        } else {
                            navigate(`/for-agents/${listing.mls_source}/${listing.mls_number || listing.id}/calendar`)
                        }
                    } else {
                        showingInstance();
                    }
                } else {
                    showingInstance();
                }
            } else {
                if (user.user_type === 'agent') {
                    if (user.agent_profile.id === listing.agent) {
                        navigate(`/manage-listings/${listing.id}/showing-form`)
                    } else {
                        navigate(`/showing-request/${listing.mls_source}/${listing.mls_number || listing.id}/calendar`)
                    }
                } else {
                    navigate(`/showing-request/${listing.mls_source}/${listing.mls_number || listing.id}/calendar`)
                }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            setModal(true)
        }
    }, [listing, user])

    const onMakeOffer = () => {
        let url = `https://www.getmoreoffers.com/agent-offer?propid=${listing.mls_number}`
        if (user.user_type === 'agent') {
            url = url + `&agentName=${user.first_name} ${user.last_name}`
            url = url + `&license=${user.agent_profile.license_number}`
            url = url + `&email=${user.email}`
            url = url + `&phone=${user.phone_number}`
            url = url + `&companyName=${user.agent_profile.company_name}`
        }
        if (user.user_type === 'buyer') {
            url = url + `&agentName=${user.first_name} ${user.last_name}`
        }

        window.open(url);
    }

    const checkIfSaved = useCallback((id) => {
        let saved = false
        savedListings.map(item => {
            if (item.listing.id === id) {
                saved = true
            }
        })
        return saved
    }, [savedListings])

    const onClickSave = async (saved, listing) => {
        if (!saved) {
            try {
                const data = {
                    user: user.id,
                    listing: listing
                }
                await dispatch(actions.listing.postSavedListing(data));
                await dispatch(actions.listing.fetchSavedListings())
            } catch (error) {
                console.log(error)
            }
        } else {
            try {
                const savedListing = savedListings.filter(item => item.listing.id === listing)[0]
                await dispatch(actions.listing.deleteSavedListing(savedListing.id));
                await dispatch(actions.listing.fetchSavedListings())
            } catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <div className='listing-details-wrapper'>
            <AuthForms modal={modal} setModal={setModal} />
            <PageWrapper style={{ background: '#F3F3F3' }}>
                <CustomContainer>
                    <div className='upper-wrapper'>
                        <div className='listing-info-container'>
                            <MediaGallery data={listing.images} onMore={onViewGallery} />
                            <Separator height={16} />
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <ListingStatus color={listing.listing_status_color} text={listing.listing_status} style={{ fontSize: 14, maxWidth: '100%' }} />
                                <div className='time'>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <g clipPath="url(#clip0_754_69)">
                                            <path d="M7.08334 1.39162C7.71179 1.75448 8.23457 2.27518 8.59993 2.90217C8.9653 3.52916 9.16058 4.2407 9.16644 4.96635C9.1723 5.692 8.98854 6.4066 8.63335 7.03941C8.27816 7.67222 7.76386 8.2013 7.14136 8.57426C6.51886 8.94722 5.80975 9.15113 5.08422 9.16582C4.35869 9.1805 3.64191 9.00544 3.00482 8.65798C2.36774 8.31051 1.83246 7.80268 1.45195 7.18476C1.07145 6.56684 0.858931 5.86025 0.835427 5.13496L0.833344 4.99996L0.835427 4.86496C0.858762 4.14537 1.06816 3.44411 1.44319 2.82954C1.81823 2.21497 2.34612 1.70806 2.97538 1.35824C3.60465 1.00842 4.31382 0.827623 5.03376 0.833473C5.7537 0.839324 6.45985 1.03162 7.08334 1.39162ZM5.00001 2.49996C4.89795 2.49997 4.79945 2.53744 4.72319 2.60526C4.64692 2.67307 4.5982 2.76652 4.58626 2.86787L4.58334 2.91662V4.99996L4.58709 5.05454C4.59659 5.12683 4.6249 5.19536 4.66918 5.25329L4.70543 5.29496L5.95543 6.54496L5.99459 6.57912C6.06767 6.63582 6.15752 6.66659 6.25001 6.66659C6.3425 6.66659 6.43235 6.63582 6.50543 6.57912L6.54459 6.54454L6.57918 6.50537C6.63587 6.4323 6.66664 6.34244 6.66664 6.24996C6.66664 6.15747 6.63587 6.06761 6.57918 5.99454L6.54459 5.95537L5.41668 4.82704V2.91662L5.41376 2.86787C5.40182 2.76652 5.3531 2.67307 5.27683 2.60526C5.20057 2.53744 5.10207 2.49997 5.00001 2.49996Z" fill="#2A2A2A" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_754_69">
                                                <rect width="10" height="10" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <p>{moment(listing.created_at).fromNow(true)} on market</p>
                                </div>
                            </div>
                            <Separator height={16} />
                            <p className='id'>Listing #{listing.mls_number || listing.id}</p>
                            <Separator height={16} />
                            <h1 className="title">{listing.property_type_display} in {listing.city}</h1>
                            <Separator height={16} />
                            <h2 className="address">
                                {`${listing.address}, ${listing.city} ${listing.state} ${listing.zip_code}`}
                            </h2>
                            <Separator height={20} />
                            <div className='price-container'>
                                <p className='current-price'>{formatCurrency(listing.price)}</p>
                            </div>
                            <Separator height={20} />
                            <ul className="ammenities">
                                <li className="item">
                                    <Icons.Bed height={20} width={20} />
                                    <p className="p20">{listing.bedroom_count} Bedrooms</p>
                                </li>
                                <li className="item">
                                    <Icons.Bath height={20} width={20} />
                                    <p className="p20">{listing.bathroom_count} Baths</p>
                                </li>
                                <li className="item">
                                    <Icons.Car height={20} width={20} />
                                    <p className="p20">{listing.garage_spaces} Garage</p>
                                </li>
                                <li className="item">
                                    <Icons.Lot height={15} width={15} />
                                    <p className="p20">{listing.square_footage} Sq. Ft.</p>
                                </li>
                            </ul>
                        </div>
                        <div className='listing-showing-container'>
                            {/* <div className='compensation-concession-section'>
                                <CompensationDetails data={listing} />
                                <ConcessionDetails data={listing} />
                            </div>
                            <Separator height={16} /> */}
                            <WeeklyCalendar
                                LeftHeader={() => {
                                    return (
                                        <>
                                            {
                                                (
                                                    listing.listing_status === 'Active' || 
                                                    listing.listing_status === 'Pending' || 
                                                    listing?.listing_status?.includes('Active') ||
                                                    listing?.listing_status?.includes('Pending')
                                                ) ?
                                                <CustomButton
                                                    size={'small'}
                                                    text={'Book your Showing'}
                                                    action={onSchedule}
                                                    iconLeft={<Icons.Calendar height={16} width={16} color={'#fff'} />}
                                                />
                                                : <p style={{ fontSize: 12, color: '#242424', textAlign: 'center', fontWeight: 600 }}>Showing Service not Available <br /> <span style={{ fontSize: 10, color: '#949494' }}>This property is not on the market</span></p>
                                            }
                                        </>

                                    )
                                }}>
                                {
                                    listing.id &&
                                    <OpenHouse data={listing} />
                                }
                            </WeeklyCalendar>
                            <Separator height={16} />
                            {
                                !(user.user_type === 'agent' && user.agent_profile.id === listing.agent) &&
                                <InquiryForm data={listing} />
                            }
                            <Separator height={16} />
                            <div style={{ display: 'flex', gap: 16 }}>
                                {
                                    user.id &&
                                    <CustomButton
                                        size={'large'}
                                        style={{ width: '100%', justifyContent: 'center' }}
                                        text={checkIfSaved(listing.id) ? <p>Saved</p> : <p>Save Listing</p>}
                                        iconLeft={
                                            <Icons.Save
                                                width={18}
                                                height={28}
                                                color={checkIfSaved(listing.id) ? '#FAC91F' : '#6C767C'}
                                            />
                                        }
                                        type={'secondary'}
                                        action={() => onClickSave(checkIfSaved(listing.id), listing.id)}
                                    />
                                }
                                {
                                    (listing.listing_status !== 'Sold' || listing.listing_status !== 'Leased') &&
                                    <CustomButton
                                        style={{ width: '100%', justifyContent: 'center' }}
                                        size={'large'}
                                        text={'Make an Offer'}
                                        iconLeft={<Icons.Coins height={18} width={18} />}
                                        action={onMakeOffer}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </CustomContainer>
            </PageWrapper>
            <Separator height={44} />
            <PageWrapper style={{ background: '#F3F3F3' }}>
                <CustomContainer>
                    {
                        listing.id &&
                        <Tabs data={listing} />
                    }
                </CustomContainer>
            </PageWrapper>
            <Separator height={40} />
            <PageWrapper style={{ background: '#F3F3F3' }}>
                <CustomContainer style={{ display: 'flex', justifyContent: 'center' }}>
                    <div className='neraby-listings'>
                        {
                            !loadingProperties
                                ?
                                <>
                                    {
                                        nearbyListing.length > 0 &&
                                        <Splide
                                            hasTrack={false}
                                            options={{
                                                type: 'loop',
                                                rewind: true,
                                                pagination: false,
                                                arrows: true,
                                                focus: 'left',
                                                gap: 30,
                                                perPage: 4,
                                            }}
                                        >
                                            <div className='splide-header'>
                                                <p>Nearby Properties</p>
                                                <div className="splide__arrows">
                                                    <div className="splide__arrow splide__arrow--prev">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={16}
                                                            height={16}
                                                            viewBox="0 0 16 16"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M10.0404 3.95955C10.431 4.35007 10.431 4.98324 10.0404 5.37376L7.41421 7.99999L10.0404 10.6262C10.431 11.0167 10.431 11.6499 10.0404 12.0404C9.64992 12.431 9.01675 12.431 8.62623 12.0404L5.29289 8.7071C4.90237 8.31657 4.90237 7.68341 5.29289 7.29288L8.62623 3.95955C9.01675 3.56903 9.64992 3.56903 10.0404 3.95955Z"
                                                                fill="#5F5F5F"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <div className="splide__arrow splide__arrow--next">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={16}
                                                            height={16}
                                                            viewBox="0 0 16 16"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M5.9594 3.95955C6.34992 3.56903 6.98309 3.56903 7.37361 3.95955L10.7069 7.29288C11.0975 7.68341 11.0975 8.31657 10.7069 8.7071L7.37361 12.0404C6.98309 12.431 6.34992 12.431 5.9594 12.0404C5.56887 11.6499 5.56887 11.0167 5.9594 10.6262L8.58562 7.99999L5.9594 5.37376C5.56887 4.98324 5.56887 4.35007 5.9594 3.95955Z"
                                                                fill="#5F5F5F"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <SplideTrack>
                                                {
                                                    nearbyListing.map((item, index) => {
                                                        return (
                                                            <SplideSlide key={index}>
                                                                <ListingCard data={item} newTab />
                                                            </SplideSlide>
                                                        )
                                                    })
                                                }
                                            </SplideTrack>
                                        </Splide>
                                    }
                                </>
                                : <Loading background={'transparent'} />
                        }
                    </div>
                </CustomContainer>
            </PageWrapper>
            <Separator height={32} />
            <PageWrapper style={{ background: '#F3F3F3' }}>
                <CustomContainer style={{ display: 'flex', justifyContent: 'center' }}>
                    <div className='neraby-listings'>
                        {
                            !loadingProperties
                                ?
                                <>
                                    {
                                        similarListing.length > 0 &&
                                        <Splide
                                            hasTrack={false}
                                            options={{
                                                type: 'loop',
                                                rewind: true,
                                                pagination: false,
                                                arrows: true,
                                                focus: 'left',
                                                gap: 30,
                                                perPage: 4,
                                            }}
                                        >
                                            <div className='splide-header'>
                                                <p>Similar Properties</p>
                                                <div className="splide__arrows">
                                                    <div className="splide__arrow splide__arrow--prev">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={16}
                                                            height={16}
                                                            viewBox="0 0 16 16"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M10.0404 3.95955C10.431 4.35007 10.431 4.98324 10.0404 5.37376L7.41421 7.99999L10.0404 10.6262C10.431 11.0167 10.431 11.6499 10.0404 12.0404C9.64992 12.431 9.01675 12.431 8.62623 12.0404L5.29289 8.7071C4.90237 8.31657 4.90237 7.68341 5.29289 7.29288L8.62623 3.95955C9.01675 3.56903 9.64992 3.56903 10.0404 3.95955Z"
                                                                fill="#5F5F5F"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <div className="splide__arrow splide__arrow--next">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={16}
                                                            height={16}
                                                            viewBox="0 0 16 16"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M5.9594 3.95955C6.34992 3.56903 6.98309 3.56903 7.37361 3.95955L10.7069 7.29288C11.0975 7.68341 11.0975 8.31657 10.7069 8.7071L7.37361 12.0404C6.98309 12.431 6.34992 12.431 5.9594 12.0404C5.56887 11.6499 5.56887 11.0167 5.9594 10.6262L8.58562 7.99999L5.9594 5.37376C5.56887 4.98324 5.56887 4.35007 5.9594 3.95955Z"
                                                                fill="#5F5F5F"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <SplideTrack>
                                                {
                                                    similarListing.map((item, index) => {
                                                        return (
                                                            <SplideSlide key={index}>
                                                                <ListingCard data={item} newTab />
                                                            </SplideSlide>
                                                        )
                                                    })
                                                }
                                            </SplideTrack>
                                        </Splide>
                                    }
                                </>
                                : <Loading background={'transparent'} />
                        }
                    </div>
                </CustomContainer>
            </PageWrapper>
        </div>
    )
}


export default ListingDetail;